//import dayjs from "dayjs";

export const getCampaignBoxes = (campaigns, priceData) => {
  // const today = dayjs().startOf("day").add(1, "day").toISOString();
  const validCampaigns = campaigns.filter((campaign) => {
    if (
      campaign.filterField.pmInStock === "yes" &&
      (!priceData || !priceData.sellingPrice?.value)
    ) {
      return false;
    }
    if (
      campaign.filterField.pmInStock?.pmSpecialPrice?.value === "yes" &&
      (!priceData?.sellingPrice?.value ||
        (priceData?.omnibusPrice?.value &&
          priceData?.sellingPrice?.value >= priceData?.omnibusPrice?.value) ||
        (!priceData?.omnibusPrice?.value &&
          priceData?.sellingPrice?.value >= priceData?.msrpPrice?.value))
    ) {
      return false;
    }
    // return campaign.pmStart.value <= today && campaign.pmStart.content.pmEnd >= today;
    return true;
  });
  const isDiscount =
    priceData?.sellingPrice?.value &&
    ((priceData?.omnibusPrice?.value &&
      priceData.sellingPrice.value < priceData.omnibusPrice.value) ||
      (!priceData?.omnibusPrice?.value &&
        priceData?.msrpPrice?.value &&
        priceData.sellingPrice.value < priceData.msrpPrice.value));
  // Se c'è lo sconto e il flag sconto, devo veder comparire sia il componente normale
  // sia quello con lo sconto, quindi duplico e cambio l'id per non rimuoverlo tra i doppioni
  // ma riconoscerlo per rimuoverlo se c'è già un altro tag sconto
  return validCampaigns
    .map((campaign) =>
      campaign?.boxAndPosition?.map((box) =>
        box?.webContent && isDiscount && campaign.tagActive
          ? [
              {
                ...box.webContent,
                price: priceData,
                id: box.webContent + "_price",
              },
              box.webContent,
            ]
          : box?.webContent
      )
    )
    .flat(2)
    .filter(Boolean);
};
